import {ForecastMapFrame} from '../../api/types';

// Which image the active view actually displays for a frame: the interactive
// map drapes the small Web-Mercator overlay (~100-250 kB) — or, on the GPU
// raster path, the scalar data texture — while the flipbook shows the full
// styled render (1-2.5 MB on global models). Preloading must follow the
// view, otherwise interactive playback warms megabytes of styled frames
// that are never shown (a 209-frame GFS loop ≈ 300 MB of wasted fetches).
export type FramePreloadMode = 'overlay' | 'scalar' | 'flipbook';

export const frameImageUrl = (
  frame: ForecastMapFrame | undefined,
  mode: FramePreloadMode,
): string | undefined => {
  if (mode === 'overlay') {
    return frame?.overlay_url ?? undefined;
  }
  if (mode === 'scalar') {
    // No overlay fallback: a frame without a texture renders nothing on
    // the raster path, so its overlay image would be a wasted fetch.
    return frame?.scalar_url ?? undefined;
  }
  return frame?.webp_url ?? frame?.png_url ?? undefined;
};
